import { inject } from 'vue'
import { PremiseCheckerKey } from '~/api/symbols'
import { SwitchingPremisesApi, SwitchingPremiseViolationsResponse } from '@gridcon-energy/schaltungstool-backend'
import type { AxiosPromise, AxiosRequestConfig } from 'axios'

/**
 * De-dupe expensive API calls
 */
export class SwitchingPremiseChecker {
  private client: SwitchingPremisesApi
  private runningRequests = new Map<string, AxiosPromise<SwitchingPremiseViolationsResponse>>()

  constructor(client: SwitchingPremisesApi) {
    this.client = client
  }

  /**
   * Naively checks if a request is already running and return it, else start new request
   */
  check(activityId: number, dateFrom?: string, dateTo?: string, byHour?: boolean, options?: AxiosRequestConfig) {
    // Create request signature
    const requestSignature = JSON.stringify([
      activityId,
      dateFrom,
      dateTo,
      byHour,
      options,
    ])

    // Return running request if same request is already running
    const runningRequest = this.runningRequests.get(requestSignature)
    if (runningRequest) {
      return runningRequest
    }

    // Create new request for signature and save it
    const request = this.client
      .checkPremisesEquipment(activityId, dateFrom, dateTo, options as any)
      .then((response) => {
        // After fulfillment, clear running request status
        this.runningRequests.delete(requestSignature)
        return response
      })
    this.runningRequests.set(requestSignature, request as AxiosPromise<SwitchingPremiseViolationsResponse>)
    return request
  }
}

export function injectPremiseChecker(): SwitchingPremiseChecker {
  const premiseChecker = inject(PremiseCheckerKey)
  if (!premiseChecker) {
    throw Error('PremiseChecker missing')
  }
  return premiseChecker
}
